import angular from 'angular';
import constants from 'app/constants';
import {
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import controller from './report-instance-comment.controller';
import directive from './report-instance-comment.directive';

import editReportInstanceCommentDialog from '../../../../../../dialog.editReportInstanceCommentDialog';

export default angular.module('app.components.reports.generatedReports.reportInstanceComment', [
  alerts,
  confirmDialog,
  constants,
  docDataService,
  editReportInstanceCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('grReportInstanceComment', directive)
  .controller('GRReportInstanceCommentController', controller)
  .name;

console.log('app.components.reports.generatedReports.reportInstanceComment created');
